import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Visual chemistry teaching collection for middle school, high school, introductory college and homeschool teachers. 6 complete volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nv0z3w0wmu6q">
      <MetaPixel data-id="element-1" data-mp="st2hsfuf4rho" />
      <main data-id="element-2" data-mp="swqbbezv5dwe">
        <Hero data-id="element-3" data-mp="36hxla6f4y2t" />
        <LookInsideCarousel data-id="element-4" data-mp="3688rpx40wyp" />
        <ProblemSection data-id="element-5" data-mp="356tf9929ob6" />
        <SystemSection data-id="element-6" data-mp="34nd1wz277z9" />
        <ModulesSection data-id="element-7" data-mp="3uct4vo20uv2l" />
        <BonusSection data-id="element-8" data-mp="3udknzzefn0bz" />
        <UrgencySection data-id="element-9" data-mp="3ubzu8bzxzlf6" />
        <PricingSection data-id="element-10" data-mp="3uevs60bsia3m" />
        <GuaranteeSection data-id="element-11" data-mp="d4o09u01u88q" />
        <FAQ data-id="element-12" data-mp="d4xlz5e29t8m" />
        <ClosingSection data-id="element-13" data-mp="d3cvprys4wgk" />
        <SummaryTable data-id="element-14" data-mp="d2l9h7r2ob2y" />
        <FinalCta data-id="element-15" data-mp="85l12q6r2w8o" />
      </main>
      <Footer data-id="element-16" data-mp="85b8cuubmaza" />
      <PurchaseNotification data-id="element-17" data-mp="86w60tbxma1d" />
    </div>;
}